
// TODO: replace the hardcoded strings on this component!!!

import React from 'react';
import {connectEvent, connectI18n} from '../../connects';
import {compose} from 'redux';
import {connect} from 'react-redux';
import Screen from '../Screen';
import TopBar from '../../elements/TopBar/TopBar';
import RoundImage from '../../elements/RoundImage';
import SocialMenu from '../../elements/SocialMenu/SocialMenu';
import ButtonLink from '../../elements/ButtonLink';
import ContainedImage from '../../elements/ContainedImage';
import moment from 'moment';
import Scrollable from '../../elements/Scrollable';
import VerticalCenter from '../../elements/VerticalCenter';

import './EventIsClosed.scss';

class EventIsClosed extends React.Component {
    render() {
        let {i18n, event, username} = this.props,
            header = (
                <div>
                    <TopBar event={event} returnURL="/">
                        {i18n['eventclosed.title']}
                    </TopBar>
                    <div className="whitebg" style={{padding: 45}}>
                        <RoundImage src={event.icon_url} size={80} style={{backgroundColor: '#d15215', margin: '0 auto ', display: 'block'}} />
                    </div>
                </div>
            ),
            footer = (
                <div>
                    {/*<ButtonLink>
                        <ContainedImage src="/img/Deelnemers_icon.png" />
                        {i18n['label.my.contacts']}
                    </ButtonLink>*/}
                    <ButtonLink href="https://networkapp.eu">
                        <ContainedImage src="/img/Netwerkapp.png" />
                        {i18n['label.networkapp-promotion']}
                    </ButtonLink>
                    <SocialMenu />
                </div>
            ),
            // hello = 'Hi {0}'.replace('{0}', username),
            hello = this.props.locale == 'de' ? 'Hallo ' + this.props.fullName : 'Hi ' + this.props.firstName,
            niceseenyou = i18n['eventclosed.niceseenyou'].replace('{0}', event.name).replace(
                '{1}',
                moment(event.start_utc)
                    .local()
                    .format('D MMM')
            );

        return (
            <Screen className="EventIsClosed" header={header} footer={footer}>
                <Scrollable>
                    <VerticalCenter>
                        <div className="text greeting">{hello}</div>
                        <br />
                        <div className="text">{niceseenyou}</div>
                        <div className="text">{i18n['eventclosed.closedevent']}</div>
                        <br />
                        <div className="text">{i18n['eventclosed.contacts']}</div>
                        <div className="text">{i18n['eventclosed.bye']}</div>
                        <br />
                        <div className="text">{i18n['eventclosed.team']}</div>
                    </VerticalCenter>
                </Scrollable>
            </Screen>
        );
    }
}

export default compose(
    connectEvent,
    connectI18n,
    connect((state, props) => ({
        firstName: state.session.user.first_name,
        fullName: [state.session.user.first_name, state.session.user.last_name].filter(v => !!v).join(' '),
        locale: props.eventId ? _.get(state, `events[${props.eventId}].event.language`, state.i18n.locale) : state.i18n.locale,
    }))
)(EventIsClosed);
